
// Define verifyCertificate in global scope
window.verifyCertificate = async (file) => {
    try {
        const injiVerifySDK = await import('inji-verify-sdk');
        const { vcVerification } = injiVerifySDK;
        // console.log('In verifyCertificate');
        // Create a timeout promise that rejects after 10 seconds
        const timeoutPromise = new Promise((_, reject) => {
            // console.log('In timeout promise');
            setTimeout(() => {
                // console.log('In timeout');
                reject(new Error('Certificate verification finished.'));
            }, 10000);
        });
        
        // Race the verification against the timeout
        const response = await Promise.race([
            vcVerification(file, process.env.VERIFY_TT_URL),
            timeoutPromise
        ]);
        // console.log(response);
        return response;
    } catch (error) {
        return {
            status: "FAILURE",
            data: {},
            error: error.message || "Unknown error occurred"
        };
    }
};

// Legacy module export for ESM contexts
export const verifyCertificate = window.verifyCertificate;
